<template>
  <div class="order-container bgc-gradient">
    <div style="font-weight: bold;">
      <Header  title="月度需求管理"></Header></div>
    <Search @onFilter="onFilter" :keyName="keyName" @onSearch="onSearch"></Search>
    <van-tabs v-model="activeTab">
      <van-tab v-for="item in tabList" :key="item.key" :name="item.key" :title="item.name"></van-tab>
      <div class="card-header">
        <div class="info">
          <div>
            <span class="info-title">产品大类：</span>
            <span class="info-value" style="font-weight: bold;"></span>
          </div>
          <div>
            <span class="info-title">月需求量：</span>
            <span class="info-value" style="font-weight: bold;"></span>
          </div>
        </div>
      </div>
      <Scroll ref="wrapper" :listenScroll="false" :pullUpLoad="pullUpLoadObj" @pullingUp="onPullUpLoad" :pullDownRefresh="pullDownRefreshObj" @pullingDown="onPullDownRefresh">
        <RequireMonthCard v-for="(item, index) in dataList" :key="index" :complaint="item"></RequireMonthCard>
        <van-empty v-if="dataEmpty" class="custom-empty" description="暂无数据"></van-empty>
      </Scroll>
    </van-tabs>

    <van-popup v-model="filterFlag" position="right" :overlay="true">
      <FilterList :brandList="brandList" @refreshData="refreshData"></FilterList>
    </van-popup>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Search from "./components/Search.vue";
import RequireMonthCard from "./components/RequireMonthCard";
import FilterList from "./components/FilterList";
import transactionApi from "@/request/transactionApi";
import monthApi from "@/request/month-requirementApi";
import Scroll from "@/components/Scroll";
export default {
  name: "Funds",
  components: {
    Header,
    Search,
    RequireMonthCard,
    FilterList,
    Scroll,
  },
  data() {
    return {
      activeTab: "1", //即将开始
      tabList: [
        {
          key: "1",
          name: "全部",
        },
        {
          key: "2",
          name: "待审核",
        },
        {
          key: "3",
          name: "已生效",
        },
        {
          key: "4",
          name: "已驳回",
        },
      ],
      keyName: "请输入关键字查询",
      orderStatus: "0",
      filterFlag: false,
      orderList: [],
      sellers: [],
      brandList: [
      {
          id: "all",
          name: "状态（单选）",
          nameKey: "bigProductType",
          multiple: false,
          close: false,
          options: [
            {
              key: "",
              value: "全部",
              selected: true,
            },
            {
              key: "01",
              value: "待审核",
              selected: false,
            },
            {
              key: "02",
              value: "已生效",
              selected: false,
            },
            {
              key: "03",
              value: "已驳回",
              selected: false,
            },
          ],
        },
      ],
      searchForm: {
        commodityName:"",
        consigneeStatus:"",
        consigneeType:"",
        status:"",
        
      },
      hasNextPage: true,
      scrollParams: {
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "",
        pullUpLoadNoMoreTxt: "",
      },
      formPage: {
        currentPage: 1,
        pageSize: 10,
      },
      dataList:[],
      SearchStr:"",
    };
  },
  computed: {
    pullUpLoadObj() {
      return this.scrollParams.pullUpLoad
        ? {
            threshold: parseInt(this.scrollParams.pullUpLoadThreshold),
            txt: {
              more: this.scrollParams.pullUpLoadMoreTxt,
              noMore: this.scrollParams.pullUpLoadNoMoreTxt,
            },
          }
        : false;
    },
    pullDownRefreshObj() {
      return this.scrollParams.pullDownRefresh
        ? {
            threshold: parseInt(this.scrollParams.pullDownRefreshThreshold),
            stop: parseInt(this.scrollParams.pullDownRefreshStop),
          }
        : false;
    },
    statusType() {
      return this.$store.state.valueSet.NG_ORDER_STATUS;
    },
    orderType() {
      return this.$store.state.valueSet.NG_ORDER_TYPE;
    },
    LNGmaterialCode() {
      return this.$common.interfacePath.LngMaterialCode;
    },
    PNGmaterialCode() {
      return this.$common.interfacePath.PngMaterialCode;
    },
    dataEmpty() {
      return this.dataList.length == 0 && !this.loading;
    },
  },
  watch: {},
  // created() {
  //   this.getBrandList();
  // },
  mounted() {
    this.getOrderList();
  },
  methods: {
    // 筛选
    onSearch(val){
      this.searchForm.commodityName=val;
      this.getOrderList(1)
    },
    onFilter() {
      this.filterFlag = !this.filterFlag;
    },
    //上拉加载
    onPullUpLoad() {
      if (!this.hasNextPage) {
        this.$refs.wrapper.forceUpdate(false);
        return false;
      } else {
        setTimeout(() => {
          this.formPage.currentPage++;
          this.getOrderList();
        }, 1000);
      }
    },
    //下拉刷新
    onPullDownRefresh() {
      setTimeout(() => {
        this.formPage.currentPage = 1;
        this.orderList = [];
        this.getOrderList();
      }, 1000);
    },
    // 状态筛选
   async refreshData(queryList) {
      // console.log(queryList);
      this.searchForm.consigneeStatus= await queryList[0].options.filter((res)=>{
          return res.selected==true
      })[0].key;
      let params = Object.assign({}, this.searchForm, this.formPage);
      transactionApi.listBuyerConsignee(params).then((res)=>{
        if (res.returnCode == "0") {
          if (res.result.dataList==null) {
            this.dataList=[];
          }else{
            this.dataList=res.result.dataList;
          }
          this.filterFlag=false;
        }
      })

    },
    async getOrderList(str) {
      // let params = {
      //   dto: {
      //     ...this.form,
      //   },
      //   ...this.pageInfo,
      let params = Object.assign({},{order: "createTime",key: "DESC"},{dto:this.searchForm}, this.formPage);
      monthApi.listPageBuyer(params).then((res) => {
        if (res.returnCode == "0") {
          if(str=='1'){
            return this.dataList = res.result.dataList;
          }
          if(this.searchForm.commodityName!=""){
            let tempList = res.result.dataList;
            this.dataList = this.dataList.concat(tempList);
            this.hasNextPage = res.result.hasNextPage;
          }else{
            this.dataList = res.result.dataList;
          }

          if (this.hasNextPage) {
            this.$refs.wrapper.forceUpdate(true);
          } else {
            this.$refs.wrapper.forceUpdate(false);
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>
<style lang="stylus" scoped>
.order-container >>> .van-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-container >>> .van-tabs__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab {
  font-size: 32px;
  line-height: 45px;
}

.order-container >>> .van-popup {
  height: 100%;
  width: 576px;
}

.order-container >>> .van-empty__image {
  width: 360px;
  height: 360px;
}

.order-container >>> .van-empty__description {
  font-size: 0.32rem;
  line-height: 0.38rem;
}

.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tabs-container {
    flex: 1;
    display: flex;
    overflow: hidden;
  }
}

/* ---------- */
.order-container {
  >>> .van-tabs__wrap {
    height: 60px !important;
  }

  >>> .van-tabs__nav {
    background-color: transparent;
  }

  >>> .van-tab__text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #666666;
  }

  >>> .van-tab--active .van-tab__text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #333333;
  }

  .card-header {
    margin: 32px 0;
    padding: 0 32px;

    .info {
      padding: 36px 32px;
      background: #FFFFFF;
      border-radius: 16px 16px 16px 16px;
      display: flex;

      >div{
        height 40px
        width 50%
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #666666;
        span{
          line-height: 40px;
        }
      }
    }
  }
}

/deep/ .van-tabs__line {
  width: 24px;
  height: 4px;
  background: #E0000C;
  border-radius: 3px 3px 3px 3px;
}
</style>